// extracted by mini-css-extract-plugin
export default {"container":"quality_container__iHpgy","quality_text":"quality_quality_text__6Y-eV","quality_img":"quality_quality_img__ptxKJ","line":"quality_line__cLudS"};